import { useEffect, useState } from "react";
import { useCompany } from "@/hooks/useCompany";
import { isDemoCompanyId } from "@/services/demoTenant";

/**
 * True when the currently active company is the isolated Demo Company.
 * Used for the permanent DEMO badge and to suppress destructive/external
 * affordances that would be meaningless in a demonstration tenant.
 */
export function useDemoCompany() {
  const { companyId, loading } = useCompany();
  const [isDemo, setIsDemo] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!companyId) {
      setIsDemo(false);
      setChecking(loading);
      return;
    }
    setChecking(true);
    isDemoCompanyId(companyId)
      .then((v) => { if (!cancelled) setIsDemo(v); })
      .catch(() => { if (!cancelled) setIsDemo(false); })
      .finally(() => { if (!cancelled) setChecking(false); });
    return () => { cancelled = true; };
  }, [companyId, loading]);

  return { isDemo, companyId, loading: loading || checking };
}
